import moment from 'moment'

export default {
  onHashChange: () => {
    const shouldEvaluateNextBusinessDay = window.location.hash.match(
      /(.*)#!\/shipping-method(.*)/
    )
    if (shouldEvaluateNextBusinessDay) {
      const container = document.getElementById('snipcart-shippings-list')
      container.addEventListener(
        'DOMNodeInserted',
        () => {
          const targetResults = document.getElementsByClassName(
            'snip-product__important'
          )
          const target = targetResults ? targetResults[0] : null
          if (!target) {
            return
          }

          const nextBusinessDay = moment()
            .startOf('day')
            .add({ day: 1 })
          target.textContent = nextBusinessDay.format('MMMM Do YYYY')
        },
        false
      )
    }
  }
}
